import { getEdchKeySession } from "../services/v3/header"
import * as MockJSBridge from "./mock-jsbridge"
import * as NativeJSBridge from "./native-jsbridge"

export const EVT_PAGE_VISITED = 10001
export const EVT_PAGE_LOADING = 10002
export const EVT_PAGE_STAYING = 10003
export const EVT_ITEM_EXPOSED = 10004
export const EVT_CLICK = 10100

const isEnvProduction = process.env.NODE_ENV === "production"

NativeJSBridge.getNativeInfo()
  .then((res) => res && Object.keys(res).length > 0)
  .catch(() => false)
  .then((isApp) => {
    if (
      typeof window !== "undefined" &&
      typeof (window as any).__IS_APP__ === "undefined"
    ) {
      ;(window as any).__IS_APP__ = isApp
    }
  })

export type NativeInfo = {
  email: string
  token: string
  gtoken: string
  appName: string
  appVersion: string
  domain: string
  country: string
  isMegaApp?:string
  openudid?: string
  accessToken?: string
  userInterfaceStyle?: "0" | "1" | "2" // 0-未知 1-亮色模式 2-暗黑模式
  categories?: string[]
  user_id?: string // Mega App 注入的用户 ID，用于神策 distinct_id
}

export type TrackParams = {
  module?: string
  sub_module?: string
  event_type?: number
  click_data?: {
    url?: string
    name?: string
    label?: string
    sku?: string
    price?: number
    number?: number
    extra?: string
  }
  page_data?: {
    code?: number
    message?: string
    duration?: number
  }
  extra1?: string
  extra2?: string
  log_version?: number
}

export type HistoryNoButtonConig = Partial<{
  station_sn: string
  device_sn: string
  baby_id: string
}>

export type navigateRNPamras = {
  plugin_id: string
  device_sn?: string
  initial_routeName: string
  initial_properties?: { [x: string]: any }
}

type NavbarConfig = {
  hideNavbar: boolean // 告诉app是否需要隐藏app导航栏，默认不隐藏
  navTitle?: string // 导航栏标题 （没有就不传）
  /**
   * 0: Android 物理返回键 读取 AndroidBack 方法
   *
   * 1: 默认返回浏览器上一级，已经是开始页面，返回上一个 webview
   *
   * 2：关闭当前webview 返回上一个webview
   */
  backOperation: 0 | 1 | 2 // 控制返回逻辑
  extraJsPath?: string // 注入 webview js 的路径
  immersiveMode?: boolean // 沉浸式布局 默认非沉浸式，设置true时，同时需要设置hideNavbar为true
}

export type BabyHistoryData = {
  station_sn?: string
  device_sn?: string
  baby_id?: number
  history_data: {
    startTime: number
    endTime: number
    status?: 0 | 1
    isNight?: 0 | 1
    data?: {
      historyDataValue: [number, number, number] // 心率， 血氧， 运动量
      isHrAbnormal: 0 | 1
      sleepStatus: number
    }[]
  }
}

export type BaybyHearRateInfo = {
  device_sn: string
  station_sn: string
  endTime: number
  startTime: number
  heartRateDatas: Array<{
    heartRateDataValue: number
    isHrAbnormal: number
    timeStamp: number
  }>
}

export type BabyBloodOxygenInfo = {
  device_sn: string
  station_sn: string
  endTime: number
  startTime: number
  bloodOxygenDatas: Array<{
    bloodOxygenDataValue: number
    timeStamp: number
  }>
}

const JSBridgeStyleStr =
  "padding: 4px; background-color: orange; border-radius: 5px; color: #FFF"

const logOnlyOnce = (() => {
  let flag = false
  return (fn: () => void) => {
    if (flag) return
    flag = true
    fn()
  }
})()

function getJSBridge() {
  const usingMockJSBridge =
    Object.prototype.hasOwnProperty.call(window, "__SANDBOX") ||
    window.location.search?.indexOf("_MOCK_JS_BRIDGE=1") > -1 
    || !isEnvProduction
  // ||!(window as any).__IS_APP__

  logOnlyOnce(() => {
    console.info(
      `%c [JSBridge]: You are currently using ${
        usingMockJSBridge ? "MockJSBridge" : "NativeJSBridge"
      }. `,
      JSBridgeStyleStr
    )
  })
  return usingMockJSBridge ? MockJSBridge : NativeJSBridge
}


export function openWebview(url: string) {
  return getJSBridge().openWebview(url)
}

export function setNavbar(config: NavbarConfig) {
  return getJSBridge().setNavbar(config)
}

export function setNavbarAsync(config: NavbarConfig) {
  return getJSBridge().setNavbarAsync(config)
}

export function backToNative() {
  return getJSBridge().backToNative()
}

export function getNativeInfo() {
  return getJSBridge().getNativeInfo() as Promise<NativeInfo>
}

export function getAppName(): Promise<string> {
  return getJSBridge().getAppName() as Promise<string>
}

export function uploadHelpEvent(key: string, helpful: number, level: string) {
  return getJSBridge().uploadHelpEvent(key, helpful, level)
}

/** 事件上报, 数据非永久保存, 阶段性删除 */
export function uploadTrackings(params: Record<string, unknown>) {
  return getJSBridge().uploadTrackings(params)
}

export function openBrowser(url: string) {
  return getJSBridge().openBrowser(url)
}

/** 商业化埋点上报 */
export function track(params: TrackParams) {
  return getJSBridge().track(params)
}

export function togglePullToRefresh(toggle: boolean) {
  return getJSBridge().togglePullToRefresh(toggle)
}

export function getBabyHistory() {
  return getJSBridge().getBabyHistory()
}

export function babyDashboardHistoryBottomNoButtonClicked(
  config: HistoryNoButtonConig
) {
  return getJSBridge().babyDashboardHistoryBottomNoButtonClicked(config)
}

export function getRealHeartRateInfo() {
  return getJSBridge().getRealHeartRateInfo()
}

export function realHeartRateFaqClicked() {
  return getJSBridge().realHeartRateFaqClicked()
}

export function realHeartRateShowErrorUI() {
  return getJSBridge().realHeartRateShowErrorUI()
}

export function getRealBloodOxygenInfo() {
  return getJSBridge().getRealBloodOxygenInfo()
}

export function realBloodOxygenFaqClicked() {
  return getJSBridge().realBloodOxygenFaqClicked()
}

export function realBloodOxygenShowErrorUI() {
  return getJSBridge().realBloodOxygenShowErrorUI()
}

export function encrypt(data: { type: number; data: string }) {
  return getJSBridge().encrypt(data)
}

/**
 * 解密
 * @param data type: 0 ecdh
 * @returns
 */
export function decrypt<T = any>(data: { type: number; data: string }) {
  return getJSBridge().decrypt(data) as Promise<T>
}

/**
 * 解密app header
 * @param
 * @return
 */
export function getHeaderV3(ts: string, once: string, body: string, domain?: string) {
  return getJSBridge().getHeaderV3(ts, once, body,domain)
}

/**
 * 加密v3 app
 * @param data type: 0 ecdh
 * @returns
 */
export function encryptV3<T = any>(data: { type: number; data: string; domain?: string }) {
  return getJSBridge().encryptV3(data) as Promise<T>
}

/**
 * 解密v3 h5
 * @param data
 * @param shareKey 协商key
 * @returns
 */
export async function decryptV3H5<T = any>(data: string, shareKey?: string) {
  shareKey = shareKey || (await getEdchKeySession())?.shareKey
  return getJSBridge()
    .decryptV3H5(data, shareKey)
    .catch((e) => {
      // 解密失败 返回原始数据
      return Promise.resolve(data)
    }) as Promise<T>
}

/**
 * 解密v3 app
 * @param
 * @returns
 */
export function decryptV3App<T = any>(data: { type: number; data: string; domain?: string }) {
  return getJSBridge().decryptV3App(data) as Promise<T>
}

export function exitApp() {
  return getJSBridge().exitApp() as Promise<void>
}

export function readAgreement() {
  return getJSBridge().readAgreement() as Promise<void>
}

export function startAddDevice() {
  return getJSBridge().startAddDevice() as Promise<void>
}

export function navigateRN(params: navigateRNPamras) {
  return getJSBridge().navigateRN(params) as Promise<{ code: number }>
}

export function isInApp() {
  return getJSBridge().isInApp() as Promise<boolean>
}

export function successfulWarrantySubmissions() {
  return getJSBridge().successfulWarrantySubmissions() as Promise<void>
}

/** 事件上报, 数据非永久保存, 阶段性删除 */
export function uploadTrackingsForClean(params: Record<string, unknown>) {
  return getJSBridge().uploadTrackingsForClean(params)
}

export function appLoginOut() {
  return getJSBridge().appLoginOut() as Promise<void>
}
export function showGoToRestrictedZone() {
  return getJSBridge().showGoToRestrictedZone()
}
export function pageAction(action: string) {
  return getJSBridge().pageAction(action)
}
